import { Component } from '@angular/core';
import { ConfiguratorService } from './shared/services/configurator-service/configurator.service';
import { ThemeConfigureService } from './shared/services/theme-configure-service/theme-configure-service';
import { NavigationHistoryService } from './shared/services/navigation-history.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {

  constructor(
    private themeConfigureService: ThemeConfigureService,
    // Eagerly inject so it begins tracking router events at app bootstrap,
    // before any consumer (e.g. <app-back-button>) reads the count.
    private navigationHistory: NavigationHistoryService
  ) { }

  ngOnInit() {
  //  this.themeConfigureService.getConfigurationDetail();
  }
}
